import React, { Component } from 'react';
import FontIcon             from 'material-ui/FontIcon';
import { browserHistory }   from 'react-router';
import { secondaryIcon }    from './../css/Styles';
import './../css/App.css';

class ViewMapIcon extends Component
{
    visitMap = (placeId) => {
        browserHistory.push('/place-map/' + placeId);
    };

    render = () => {
        return (
            <FontIcon
                onTouchTap={ this.visitMap.bind(this, this.props.placeId) }
                color={ secondaryIcon.color }
                style={ { ...secondaryIcon.style, float: 'right', marginLeft: '5px' } }
                className="material-icons tap-event">map</FontIcon>
        );
    }
}

export default ViewMapIcon;


// WEBPACK FOOTER //
// ./src/components/ViewMapIcon.js